import { CapaQuotationDetailedServiceType } from '@generated/graphql';
import Assets from '../Assets';

export default [
  {
    id: 1,
    name: '사형 주조',
    src: Assets.Casting.SandingImage,
    serviceEnum: CapaQuotationDetailedServiceType.SandCasting,
    url:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0'
  },
  {
    id: 2,
    name: '쉘 주조',
    src: Assets.Casting.ShellImage,
    serviceEnum: CapaQuotationDetailedServiceType.ShellCasting,
    url:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0'
  },
  {
    id: 3,
    name: '인베스트먼트 주조',
    src: Assets.Casting.InvestmentImage,
    serviceEnum: CapaQuotationDetailedServiceType.InvestmentCasting,
    url:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0'
  },
  {
    id: 4,
    name: '다이캐스팅',
    src: Assets.Casting.DieCastingImage,
    serviceEnum: CapaQuotationDetailedServiceType.DieCasting,
    url:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0'
  },
  {
    id: 5,
    name: '원심 주조',
    src: Assets.Casting.CentrifugalImage,
    serviceEnum: CapaQuotationDetailedServiceType.CentrifugalCasting,
    url:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0'
  },
  {
    id: 6,
    name: '추천이 필요합니다.',
    src: Assets.Casting.RecommendImage,
    serviceEnum: CapaQuotationDetailedServiceType.Recommend,
    url:
      'https://capa.ai/blog/posts/%EC%A3%BC%EC%A1%B0%E9%91%84%E9%80%A0-%EB%AC%B8%EC%9E%90-%EB%B0%9C%EB%AA%85-%EC%9D%B4%EC%A0%84%EB%B6%80%ED%84%B0-%EC%82%AC%EC%9A%A9%EB%90%9C-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%9B%90%EC%A1%B0'
  }
];
